import React from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

interface EditProfileModalProps {
  show: boolean;
  onHide: () => void;
  form: any;
  handleInputChange: (e: React.ChangeEvent<any>) => void; // Changed to accept any valid form control element
  onSave: () => void;
  isSaving: boolean;
}

const EditProfileModal = ({ show, onHide, form, handleInputChange, onSave, isSaving }: EditProfileModalProps) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-5">Edit Profile Information</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>First Name</Form.Label>
                <Form.Control 
                  type="text" 
                  name="user_first_name" 
                  value={form.user_first_name} 
                  onChange={handleInputChange} 
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Last Name</Form.Label>
                <Form.Control 
                  type="text" 
                  name="user_last_name" 
                  value={form.user_last_name} 
                  onChange={handleInputChange} 
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control 
              type="email" 
              name="user_email" 
              value={form.user_email} 
              onChange={handleInputChange} 
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Phone Number</Form.Label>
            <Form.Control 
              type="text" 
              name="user_mobile" 
              value={form.user_mobile} 
              onChange={handleInputChange} 
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide} disabled={isSaving}>Cancel</Button>
        <Button variant="primary" onClick={onSave} disabled={isSaving}>
          {isSaving ? "Saving..." : "Save Changes"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditProfileModal;